<template>
<span>
  {{ project && project.hasOwnProperty('name') && project.hasOwnProperty('state') && project.name !== '' && project.state !== '' ? `- ${project.name} / ${project.state}` : 'Projeto ainda não configurado' }}
</span>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'ProjectName',
    computed: {
      ...mapGetters('project', ['project'])
    },
    methods: {
      ...mapActions('project', ['fetchOne'])
    },
    mounted () {
      if (!this.project || !this.project.hasOwnProperty('name') || !this.project.hasOwnProperty('state')) {
        this.fetchOne('config')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectName.vue